module.exports = __webpack_public_path__ + "static/media/13.fec2b9aa.JPG";